"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    week_1: 'לשבוע הקרוב',
    week_2: 'לשבועיים הקרובים',
    week_3: 'לשלושת השבועות הקרובים'
  },
  ar: {
    week_1: 'للأسبوع القادم',
    week_2: 'للأسبوعين المقبلين',
    week_3: 'للأسابيع الثلاثة القادمة'
  },
  en: {
    week_1: 'For the next week',
    week_2: 'For the next two weeks',
    week_3: 'For the next three weeks'
  }
};